import { render, staticRenderFns } from "./ManualInspection.vue?vue&type=template&id=37741c19&"
import script from "./ManualInspection.vue?vue&type=script&lang=js&"
export * from "./ManualInspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports